<template>
   <div class="bgbody">
   <div>
   <van-swipe :autoplay="3000">
     <van-swipe-item v-for="(image, index) in images" :key="index" height="150">
       <img :src="image" width="100%" height="150"/>
     </van-swipe-item>
   </van-swipe>
   </div>
      <div style="padding: 10px;">
<p>职位：软件开发工程师（项目经理）</p>
<p>任职要求：</p>
<p>1、具有3年以上java底层开发技术经验，熟悉JAVA基础、JavaEE体系结构。</p>
<p>2、熟练使用SpringCloud微服务开发；熟练Docker/Kubernetes等容器技术；熟悉分布式、缓存(Redis)、消息等机制(Kafka etc)；熟悉基于Oracle/MySQL/SQL等数据库的设计和开发；熟悉基于MongoDB等非关系型数据库的设计和开发。</p>
<p>3、熟悉Oracle、MySql等数据库开发，增删改查等SQL基础扎实，有事务处理、优化、巡检等经验优先。   </p>
<p>4、熟悉VUE、Angular4 、BootStrap、layUI 、JFinal等UI者优先。</p>
<p>5、有Nginx、Redis、架构使用和配置经验者优先。</p>
<p>6、计算机或者相关专业、大学本科以上。</p>
<p>7、喜欢学习新技术，思维清晰，对新知识、新事物能很快地接受并掌握，自学能力强。</p>
<p>8、为人勤恳、踏实务实、乐于学习、善于沟通。</p>
<p>职位福利：五险一金、绩效奖金、带薪年假、弹性工作、节日福利、周末双休</p>
<p>联系人：董女士</p>
<p>电子邮箱：dhmyc@163.com</p>
      </div>
   <van-divider
     :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
   >
     <van-image
     width="50"
     height="50"
     src="../../static/images/gslogo.png"
   />
   </van-divider>
   <van-row style="font-size:14px;">
     <van-col span="24">山东晟厚网络科技有限公司</van-col>
   </van-row>
   <van-row style="font-size:14px;">
     <van-col span="24"><a style="color:#303D4E" href="https://beian.miit.gov.cn/">备案号：鲁ICP备20030160号</a></van-col>
   </van-row>
   </div>
   </template>
   <script>
    import Vue from 'vue';
    import { Swipe, SwipeItem } from 'vant';
    import { Grid, GridItem } from 'vant';
    import { Image as VanImage } from 'vant';
    import { Circle } from 'vant';
    import { Lazyload } from 'vant';
    import { Divider } from 'vant';
    import $ from 'jquery'
    import { Col, Row } from 'vant';
   
   Vue.use(Divider);
   Vue.use(Lazyload);
   Vue.use(VanImage);
   Vue.use(Grid);
   Vue.use(GridItem);
   Vue.use(Swipe);
   Vue.use(SwipeItem);
   Vue.use(VanImage);
   Vue.use(Col);
   Vue.use(Row);
   //animate.min.css
     export default {
       data() {
       return {
          images: [
           '../../static/images/banner3.png',
           '../../static/images/banner.jpg'
         ]
       };
     },
       name: 'WJWList',
       methods:{
       },
       mounted(){
          try {
       window.console && window.console.log && (console.log("山东晟厚网络科技有限公司欢迎你的加入，招贤电话：0531-85739535。")); 
       }catch (e) {}
       }
     }
   </script>
   <style>
   p{
      text-align: left;
      font-size: 15px;
      text-indent: 30px;
      line-height: 200%;
       margin: 0;
       padding: 0;
   }
     .my-swipe .van-swipe-item {
       color: #fff;
       font-size: 20px;
       line-height: 150px;
       text-align: center;
       background-color: #39a9ed;
     }
     .mfont{
       font-size:14px;
       line-height:250%;
       font-weight:bold;
     }
     .bgbody{
        background-repeat:no-repeat;
        background-position:center;
     }
   </style>


// WEBPACK FOOTER //
// src/components/QYZP.vue